import { PROVINCES } from './Common';


const LicenceTypeValues = {
    [PROVINCES.ALBERTA]: {
        CLASS_7L_LICENCE: '7L',
        CLASS_6_GDL: '6GDL',
        CLASS_6_LICENCE: '6',
    },
    [PROVINCES.ONTARIO]: {
        M1: 'M1',
        M2: 'M2',
        M: 'M',
    },
};

// Automatically flattens LicenceTypeValues for uses in type checking
const flatLicenceTypeValues = Object.values(LicenceTypeValues).flatMap(Object.values);

export { flatLicenceTypeValues };

export default LicenceTypeValues;
